export default function Copyright() {
  return (
    <span className="text-t14 lg:text-t16 text-white lg:text-app-white">
      © {new Date().getFullYear()} Darwinia Network
    </span>
  );
}
